import { useQuery } from '@tanstack/react-query';

import { dealQueryOptions, type TPostponedDealsQueryParams } from '@crm/entities/deal';

export const useGetPostponedDealsQuery = (
    queryParams: TPostponedDealsQueryParams,
    { enabled = true }: { enabled?: boolean } = {}
) =>
    useQuery({
        ...dealQueryOptions.getPostponedDealsQueryOptions(queryParams),
        enabled,
    });
